import type { OutreachRow } from '@discovr/types';
import { isInOutreach } from './handoffStates';
import { isSequenceEnded } from './rowStateLabels';

/** A replied row can still be nudged while a follow-up is owed (creator_wait), Go has armed the next step, or the agent deferred a nudge (R17-32, R17-43). */
function hasPendingNudge(row: Partial<Pick<OutreachRow, 'followup' | 'nextFollowupAt' | 'followupDeferred'>>): boolean {
  return !!row.followup || !!row.nextFollowupAt || row.followupDeferred?.action === 'nudge_after';
}

/** Pause while the thread is `contacted` or `replied` (R17-32: after a reply Pause still stops the agent's nudge); Resume whenever the row is paused (a reply never lifts a pause, so an
 *  admin must still be able to Resume after one). Unsubscribe is permanent, so an unsubscribed creator gets neither,
 *  even if a pause was set before the unsubscribe (Go keeps `status=outreach` and the pause on it). Pause is hidden once the
 *  sequence has ended: nothing is left to pause (E9-178); a replied row shows Pause only while a nudge is still pending. */
export function followupPauseAction(row: Pick<OutreachRow, 'status' | 'outreachState' | 'followupsPausedAt'> & Partial<Pick<OutreachRow, 'followup' | 'nextFollowupAt' | 'followupDeferred' | 'lastMessage'>>): 'pause' | 'resume' | null {
  if (!isInOutreach(row) || row.outreachState === 'unsubscribed') return null;
  if (row.followupsPausedAt) return 'resume';
  if (row.outreachState === 'contacted') return isSequenceEnded(row) ? null : 'pause';
  return row.outreachState === 'replied' && hasPendingNudge(row) ? 'pause' : null;
}
